/**
 * @desc 修改运输方式
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.ModifyShippingTypeRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/modifyShippingMode`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
